export default {
    enterprise: 'Enterprise',
    individual: 'Individual',
    organization: 'Organization',
};
